import { type IEngineSection } from '@framework/engine/schema/sections/IEngineSection.ts';
import type React from 'react';
import { useModuleFormSectionVisible } from '../sections-monitor/ModuleFormSectionsMonitorContext.tsx';

export interface ISharedSectionVisibilityGateProps {
  section: IEngineSection;
  children: React.ReactNode;
}

/**
 * Gate di visibilità per le sezioni condivise: non renderizza i children
 * (tipicamente il `SharedSectionWrapper`) quando la sezione non è visibile.
 *
 * Senza questo gate il box grafico della sezione condivisa resterebbe
 * visibile ma vuoto quando la regola di visibilità della sezione non è
 * verificata, perché `FillableForm` nasconde solo il contenuto interno.
 *
 * Usa lo stesso hook `useModuleFormSectionVisible` di `FillableForm`, così
 * box e contenuto compaiono e spariscono insieme.
 */
export function SharedSectionVisibilityGate(
  props: ISharedSectionVisibilityGateProps,
) {
  const { section, children } = props;
  const visible = useModuleFormSectionVisible(section);

  if (!visible) {
    return null;
  }

  return <>{children}</>;
}
